import moment from 'moment';
import lang from '../lang';

window.moment = moment;

moment.locale(lang);
